import {REPLACEABLE_CHARACTERS} from "./userContext.data";

/**
 * Parses the session object from the API response into the userData shape.
 */
export const parseSessionData = (session) => {
    const {
        customerEmail,
        customerId,
        customerName,
        customerFullName,
        customer,
        completeRegister,
        mustShowPreferenceModal,
        formKey,
    } = session;

    return {
        firstName:               customerName,
        customerId,
        customerEmail,
        customer,
        customerFullName,
        completeRegister,
        mustShowPreferenceModal,
        sessionFormKey:          formKey,
    };
};

/**
 * Parses the affiliation object from the API response.
 */
export const parseAffiliationData = (affiliation = {}) => ({
    vendor:         affiliation.vendor,
    client:         affiliation.client,
    dependents:     affiliation.dependents ?? [],
    customizations: affiliation.customizations,
});

/**
 * The keys of the inlined bootstrap payload that generalData must already carry
 * on the very first render, because the layout depends on them: `nadEnable`
 * decides which home banner block is rendered, and `storeLogo` fills the header
 * logo, which has no intrinsic size until its src resolves.
 */
const BOOTSTRAP_KEYS = ['nadEnable', 'nadImageMobile', 'nadImageDesktop', 'storeLogo'];

/**
 * Picks those keys out of the payload inlined by the server (the
 * `general_application_data` script in the page head).
 *
 * Only keys actually present are copied, so a payload without them leaves
 * generalData exactly as it was before — empty until the fetch fills it.
 */
export const parseBootstrapGeneralData = (bootstrap) => {
    if (!bootstrap) {
        return {};
    }

    return BOOTSTRAP_KEYS.reduce((seed, key) => {
        if (bootstrap[key] !== undefined) {
            seed[key] = bootstrap[key];
        }

        return seed;
    }, {});
};

/**
 * Parses the general data object from the API response.
 */
export const parseGeneralData = (data = {}, offer = {}, ctaPopUp, affiliation) => ({
    ...data,
    offer,
    ctaPopUp,
    affiliationData: parseAffiliationData(affiliation),
});

/**
 * The main purpose of this method is to add the indexer property
 * to the main location data object.
 * */
export const parseLocationData = (locationData) => {
    if (!locationData) {
        return {};
    }

    let regionIndex = locationData.name?.toLowerCase();

    Object.keys(REPLACEABLE_CHARACTERS).forEach(key => {
        regionIndex = regionIndex.replaceAll(
            `${key}`,
            REPLACEABLE_CHARACTERS[key],
        )
    })

    return {
        ...locationData,
        regionIndex
    };
}
